import "babel-polyfill";
import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/performance";
import CKEditor from "@ckeditor/ckeditor5-vue";
import VueMoment from "vue-moment";
import Chartkick from "vue-chartkick";
import Chart from "chart.js";
import VueYouTubeEmbed from "vue-youtube-embed";
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import VueIframe from "vue-iframes";
import excel from "vue-excel-export";
import "./styles/styles.scss";
import HighchartsVue from "highcharts-vue";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import VueSocialSharing from 'vue-social-sharing'
import VuePapaParse from 'vue-papa-parse'
import Embed from 'v-video-embed'
import BusinessHours from 'vue-business-hours';
import VueDragResize from 'vue-drag-resize'

import vuetify from "./plugins/vuetify";
import i18n from "./plugins/vueI18n";
import { localizedDate } from "./utils/localizedDate";
import { fixString } from "./utils/fixString";
import { CalendarFilters } from "@/models/calendar/CalendarFilters";
import { ResidentsFilters } from "@/models/resident/ResidentsFilters";
Vue.use(Embed);
Vue.use(VuePapaParse);
Vue.use(VueSocialSharing);
Vue.use(HighchartsVue);
Vue.use(excel);
Vue.use(VueYouTubeEmbed);
Vue.use(CKEditor);
Vue.use(VueMoment);
Vue.use(Chartkick.use(Chart));
Vue.use(VueIframe);
Vue.use(BusinessHours);
Vue.use(VueToast, {
  position: "top-right"
});
Vue.component('vue-drag-resize', VueDragResize)

Vue.filter('localizedDate', localizedDate);
Vue.filter('fixString', fixString);

Vue.config.productionTip = false;
Vue.config.devtools = true;

if (window.location.hostname !== 'localhost') {
  Sentry.init({
    Vue,
    dsn: 'https://fb860e02755e40cca8be3cbeccaca430@o566281.ingest.sentry.io/5708909',
    environment: process.env.NODE_ENV,
    integrations: [new Integrations.BrowserTracing()],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  })

  Sentry.setExtra('facilityId', (store?.state?.authModule?.currentFacility || 'not identified') as string);
  Sentry.setExtra('userId', (store?.state?.authModule?.user?.id || 'not identified') as string);
}

const ignoreWarnMessage =
  "The .native modifier for v-on is only valid on components but it was used on <div>.";
Vue.config.warnHandler = function (msg, vm, trace) {
  // `trace` is the component hierarchy trace
  if (msg === ignoreWarnMessage) {
    msg = null;
    vm = null;
    trace = null;
  }
};

export const eventBus = new Vue();

const firebaseConfig = {
  apiKey: process.env.VUE_APP_apiKey ?? "AIzaSyAkMS7c6iJRDc1I98xZvmHtNVv8G0f8wpc",
  authDomain: process.env.VUE_APP_authDomain ?? "reshub-test.firebaseapp.com",
  projectId: process.env.VUE_APP_projectId ?? "reshub-test",
  storageBucket: process.env.VUE_APP_storageBucket ?? "reshub-test.appspot.com",
  messagingSenderId: process.env.VUE_APP_messagingSenderId ?? "840294317578",
  appId: process.env.VUE_APP_appId ?? "1:840294317578:web:54e5a487fa6947d432e9f3",
  measurementId: process.env.VUE_APP_measurementId ?? "G-3SEW3MZD58"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const perf = firebase.performance(firebaseApp);

new Vue({
  el: "#app",
  store,
  vuetify,
  i18n,
  router,
  render: h => h(App),
  components: { App },
  created() {

    store.dispatch("setMainCalendarFilters", new CalendarFilters());

    store.commit("setMainResidentsFilters", new ResidentsFilters());

    store.dispatch("subscribeOnCurrentUser");

    firebase.auth().onAuthStateChanged(async firebaseUser => {
      store.dispatch("translate", { locale: store.state.localizationModule.facilityLocale, force: true });

      if (firebaseUser && !firebaseUser.isAnonymous) {

        const idTokenResult = await firebaseUser.getIdTokenResult();

        if(idTokenResult?.claims?.isStaff){

          await store.dispatch("autoSignIn", firebaseUser)

          firebaseUser.getIdToken().then(async function (idToken) {
            if(idToken){
              await store.dispatch("autoSignIn", firebaseUser)
            }
            else{
              await store.dispatch("userSignOut")
            }
          });
        }
      }
      else if (this.$route.meta.requiresAuth) {
        store.dispatch("userSignOut");
      }
    })
  }
});